module.exports = __webpack_public_path__ + "img/chart.319f6e65.png";